<template>
    <div>
      <unsubscribe-component></unsubscribe-component>
    </div>
</template>

<script>
import UnsubscribeComponent from "@/components/auth/UnsubscribeComponent";

export default {
    name: "Unsubscribe",
    mixins: [],
    components: {
      UnsubscribeComponent

    },
    inject: [],
    provide() {
        return {}
    },
    props: {},
    data() {
        return {}
    },
    beforeRouterEnter() {
    },
    created() {
    },
    mounted() {

    },
    beforeDestroy() {
    },
    destroyed() {
    },
    computed: {},
    methods: {},
    watch: {},
}
</script>

<style scoped>

</style>